import styled from 'styled-components';

export const TvGridWrapper = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: hidden;
  overflow-x: auto;
  position: relative;

  /* Hide scrollbars — TV screen should never show them */
  & * {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  & *::-webkit-scrollbar {
    display: none;
  }

  /* Hide the clock icon in the top-left corner of the grid */
  & .timegrid-icon {
    display: none;
  }

  /* Remove top border; disable all interactions (TV is read-only) */
  & .allie-time-grid {
    border-top: none;
    pointer-events: none;
    cursor: default;

    * {
      pointer-events: none !important;
      cursor: default !important;
    }
  }

  /* Wider columns for Producido and Avance readability on large screens */
  & .allie-time-grid .row,
  & .allie-time-grid .row.row-tv {
    grid-template-columns: 50px repeat(60, minmax(13px, 1fr)) 165px 145px !important;
  }

  /* Align Producido / Avance header cells vertically */
  & .row:first-child > *:nth-last-child(2),
  & .row:first-child > *:last-child {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  /* Inner children of Producido header should not fight for height */
  & .row:first-child > *:nth-last-child(2) > * {
    height: auto !important;
  }

  /* Header typography: neutral-60, 18px, weight 400.
     Cover both wildcard (* for experiment) and explicit class/element for Ionic. */
  & .row:first-child > *:nth-last-child(2) *,
  & .row:first-child > *:nth-last-child(2) .allie-text-body3,
  & .row:first-child > *:nth-last-child(2) ion-text,
  & .row:first-child > *:last-child,
  & .row:first-child > *:last-child *,
  & .row:first-child > *:last-child .allie-text-body3,
  & .row:first-child > *:last-child ion-text {
    color: var(--allie-color-neutral-60) !important;
    font-size: 18px !important;
    font-weight: 400 !important;
  }

  /* Remove bottom border from the minute-header row */
  & .row:first-child {
    border-bottom: none;
  }

  /* Separator between data rows */
  & .cells.row {
    border-bottom: 1px solid var(--allie-color-neutral-20);
  }

  /* Producido / Avance cells fill the full row height for correct centering */
  & .allie-time-grid .cells.row > *:nth-last-child(2),
  & .allie-time-grid .cells.row > *:last-child {
    align-self: stretch;
  }

  /* Transparent backgrounds — Producido column */
  & .allie-time-grid .cells.row > *:nth-last-child(2) {
    background-color: transparent !important;
  }
  & .allie-time-grid .cells.row > *:nth-last-child(2) .label.center {
    background-color: transparent !important;
  }

  /* Transparent backgrounds — Avance column */
  & .allie-time-grid .cells.row .label.center:last-child {
    background-color: transparent !important;
    border-width: 0 !important;
  }
  & .allie-time-grid .cells.row > *:last-child .label.center {
    background-color: transparent !important;
  }

  /* First data row: neutralise accidental match of .row:first-child */
  & .allie-time-grid .cells.row:first-child {
    background: var(--allie-color-neutral-10) !important;
  }
  & .allie-time-grid .cells.row:first-child > .label:not(:first-child)::after {
    display: none !important;
  }

  /* Data cell typography: 24px for TV readability.
     Target both the wildcard (experiment ui-lib, single ion-text) and the explicit
     class/element selectors (Ionic app ui-lib, AllieTextWrapper div + inner ion-text). */
  & .allie-time-grid .cells.row > *:nth-last-child(2) *,
  & .allie-time-grid .cells.row > *:last-child * {
    font-size: 24px !important;
    line-height: 1.2 !important;
    font-weight: 400 !important;
  }

  /* Explicit class targeting for Ionic AllieText (allie-text-* on wrapper div, ion-text inside) */
  & .allie-time-grid .cells.row > *:nth-last-child(2) .allie-text-body1,
  & .allie-time-grid .cells.row > *:nth-last-child(2) .allie-text-body2,
  & .allie-time-grid .cells.row > *:nth-last-child(2) ion-text,
  & .allie-time-grid .cells.row > *:last-child .allie-text-body1,
  & .allie-time-grid .cells.row > *:last-child .allie-text-body2,
  & .allie-time-grid .cells.row > *:last-child ion-text {
    font-size: 24px !important;
    line-height: 1.2 !important;
    font-weight: 400 !important;
  }

  /* Producido column: neutral grey (Avance keeps its completion colour) */
  & .allie-time-grid .cells.row > *:nth-last-child(2) *,
  & .allie-time-grid .cells.row > *:nth-last-child(2) .allie-text-body1,
  & .allie-time-grid .cells.row > *:nth-last-child(2) .allie-text-body2,
  & .allie-time-grid .cells.row > *:nth-last-child(2) ion-text {
    color: var(--allie-color-neutral-60) !important;
  }

  /* Hour labels in data rows + minute markers in header: 18px / 25px */
  & .allie-time-grid .cells.row > *:first-child,
  & .allie-time-grid .cells.row > *:first-child .allie-text-body2,
  & .allie-time-grid .cells.row > *:first-child ion-text,
  & .row:first-child .label.minute-header,
  & .row:first-child .label.minute-header .allie-text-body2,
  & .row:first-child .label.minute-header ion-text {
    font-size: 18px !important;
    line-height: 25px !important;
  }
`;
